import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ToastType } from '../../../core';
import { addToast } from '../../../core/actions';
import { create } from '../../actions';
import { AdminSsoForm } from '../AdminSsoForm';
export const AdminSsoCreate = () => {
    const ssoService = {};
    const dispatch = useDispatch();
    const history = useHistory();
    const [isDisabled, setIsDisabled] = useState(false);
    const [errors, setErrors] = useState({});
    const onSubmit = async (data) => {
        setIsDisabled(true);
        try {
            await dispatch(create(data));
            history.push(`/account/admin/sso-services/list`);
        }
        catch (e) {
            const errs = e.data?.error?.data;
            setIsDisabled(false);
            if (Boolean(errs)) {
                setErrors(errs);
            }
            else {
                dispatch(addToast(ToastType.error, e.message));
            }
        }
    };
    return (<>
      <header className="settings-header">
        <h2 className="header-title">Create new SSO Service</h2>
      </header>
      <AdminSsoForm onSubmit={(...data) => void onSubmit(...data)} isDisabled={isDisabled} errors={errors} ssoService={ssoService} btnMessage="Create"/>
    </>);
};
